import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { TRANSLATIONS } from "../lib/translations";

i18n.use(initReactI18next).init({
  resources: TRANSLATIONS,
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
